import React from 'react';
import mobxStore from 'mobx/rootStore';

export const MobxContext = React.createContext({
  mobxStore: mobxStore,
});
